import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconButton from '@adsk/bim360-matrix-react-icon-button';

import './SidePanelItem.scss';

class SidePanelItem extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  renderItemHeader(text, headerExtension, onClose) {
    const iconSize = '12px';
    return (
      <div className="SidePanel__item-header-container">
        <div className="SidePanel__item-header-container-content">
          <div className="SidePanel__item-header-container-content-main">
            {text}
            {headerExtension}
          </div>
          <IconButton
            onClick={onClose}
            svgId={'modal-close'}
            iconWidth={iconSize}
            iconHeight={iconSize}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        style={this.props.item.style}
        className={classNames(
          'SidePanel__item',
          { 'SidePanel__item--show': this.props.isActive },
          this.props.item.className
        )}
      >
        {this.renderItemHeader(this.props.item.label, this.props.item.headerExtension, () =>
          this.props.onClose(this.props.item.id)
        )}
        <div className="SidePanel__item-content">{this.props.item.content}</div>
      </div>
    );
  }
}

SidePanelItem.propTypes = {
  item: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SidePanelItem;
